// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__1k1u8","tag":"Tags_tag__42a_l","closeTag":"Tags_closeTag__GKgEH"};